/**
 * 高频事件调用帮助方法,将高频调用进行缓冲
 */
'use strict';
function optimizeCall() {
    var callbacks = [],
        running = false,
        callArgu;

    // fired on resize event
    function call() {
        if (!running) {
            running = true;
            callArgu = arguments;
            if (window.requestAnimationFrame) {
                window.requestAnimationFrame(runCallbacks);
            } else {
                setTimeout(runCallbacks, 66);
            }
        }

    }

    // run the actual callbacks
    function runCallbacks() {
        callbacks.forEach(function (callback) {
            callback.apply(null, callArgu);
        });
        callArgu = null;
        running = false;
    }

    // adds callback to loop
    function addCallback(callback) {

        if (callback) {
            callbacks.push(callback);
        }
    }

    function removeCallback(callback) {
        if (callback) {
            callbacks.splice(callbacks.indexOf(callback), 1)
        }
    }

    return {
        add: addCallback,
        remove: removeCallback,
        call: call
    };
}

module.exports = optimizeCall;



//////////////////
// WEBPACK FOOTER
// ./~/osx-scrollview/dist/optimizeCall.js
// module id = 224
// module chunks = 0